import API from "../api";
import {
  PayloadCommunityMembersList,
  PayloadMyCommunities,
  PayloadPostsCommunity,
  PayloadStatusCommunity,
  PayloadCommunityMembersPossibleToInvite,
} from "../types";
import { Commit } from "vuex";
export default {
  namespaced: true,
  state: {
    notificationNewCommunity: false,
    headersCommunity: "",
  },
  mutations: {
    setNotification(state: any, payload: boolean) {
      state.notificationNewCommunity = payload;
    },
    setHeadersCommunity(state: any, payload: any) {
      state.headersCommunity = payload;
    },
  },
  actions: {
    async requestCurrentCommunity(context: any, payload: number): Promise<any> {
      const { data } = await API.getCurrentCommunity(payload);
      return data;
    },
    async requestFeedCommunity(
      { commit, state }: { commit: Commit; state: any },
      payload: PayloadPostsCommunity
    ): Promise<any> {
      if (payload.params.page > 0) {
        payload = {
          ...payload,
          headers: {
            "hash-page-controll": state.headersForYou,
          },
        };
      }
      const { data, headers } = await API.getFeedCommunity(payload);
      commit("setHeadersCommunity", headers["hash-page-controll"]);
      return data;
    },
    async requestCommunities(): Promise<any> {
      const { data } = await API.getCommunities();
      return data;
    },
    async requestCommunityMembers(context: any, payload: any): Promise<any> {
      const { data } = await API.getCommunityMembers(payload);
      return data;
    },
    async requestUpdateStatusCommunity(
      context: any,
      payload: PayloadStatusCommunity
    ): Promise<any> {
      const { data } = await API.putStatusCommunity(payload);
      return data;
    },
    async requestIsNewCommunity(): Promise<any> {
      const { data } = await API.getIsNewCommunity();
      return data;
    },
    async requestCommunitiesActives(context: any, payload = ""): Promise<any> {
      const { data } = await API.getCommunitiesActives(payload);
      return data;
    },
    async requestCommunityPending({
      commit,
    }: {
      commit: Commit;
    }): Promise<any> {
      const { data } = await API.getCommunityPending();
      commit("setNotification", data);
      return data;
    },
    async requestNewCommunity(context: any, payload: any): Promise<any> {
      const { data } = await API.postNewCommunity(payload);
      return data;
    },
    async requestEditCommunity(context: any, payload: any): Promise<any> {
      const { data } = await API.putEditCommunity(payload);
      return data;
    },
    async requestInactivateCommunity(context: any, payload: any): Promise<any> {
      const { data } = await API.putInactivateCommunity(payload);
      return data;
    },
    async requestUsersToInvite(context: any, payload: any): Promise<any> {
      const { data } = await API.getUsersToInvite(payload);
      return data;
    },
    async requestInviteUser(context: any, payload: any): Promise<any> {
      const { data } = await API.putInviTeUser(payload);
      return data;
    },
    async requestInativateUser(context: any, payload: any): Promise<any> {
      const { data } = await API.putInactivateUser(payload);
      return data;
    },
    async requestMyCommunities(
      context: any,
      payload: PayloadMyCommunities
    ): Promise<any> {
      const { data } = await API.getMyCommunities(payload);
      return data;
    },
    async requestCommunityMembersList(
      context: any,
      payload: PayloadCommunityMembersList
    ): Promise<any> {
      const { data } = await API.getCommunityMembersList(payload);
      return data;
    },
    async requestPossibleUsersToInvite(
      context: any,
      payload: PayloadCommunityMembersPossibleToInvite
    ): Promise<any> {
      const { data } = await API.getPossilbeUsersToInvite(payload);
      return data;
    },
  },
  modules: {},
};
